var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "content-left border-left-3" },
      [_c("ProjectTree", { on: { "tree-node-click": _vm.onTreeNodeClick_1 } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-right" },
      [
        _c("ViewTicketList", { ref: "ticketList" }),
        _vm._v(" "),
        _c("NewTicketDialog", { ref: "newTicketDialog" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d40a78c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d40a78c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ProjectIndex.vue
// module id = 978
// module chunks = 75